import Wynyard71 from '../../../Media/BSD/Hiera/Wynyard 7.webp'
import Wynyard72 from '../../../Media/BSD/Hiera/Wynyard 7.webp'





const Wynyard7images =[
Wynyard71,Wynyard72
]

export default Wynyard7images;